import { z } from "zod";

export const CustomFieldTypeSchema = z.enum({
  STRING: "string",
  NUMBER: "number",
  BOOLEAN: "boolean",
  ENUM: "enum",
  TEXT: "text",
});

export type CustomFieldType = z.infer<typeof CustomFieldTypeSchema>;

export const CUSTOM_FIELD_TYPE_VALUES = CustomFieldTypeSchema.enum;

export const CustomFieldScopeTypeSchema = z.enum({
  EVENT: "event",
  ORGANIZATION: "organization",
});

export type CustomFieldScopeType = z.infer<typeof CustomFieldScopeTypeSchema>;

export const CUSTOM_FIELD_SCOPE_VALUES = CustomFieldScopeTypeSchema.enum;

export interface CustomFieldVisibility {
  readonly showToHosts: boolean;

  readonly showToParticipant: boolean;

  readonly useInMatching: boolean;
}
